import PaymentOrders from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders';
import { paymentOrdersLoadTrigger } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.actions';
import paymentOrdersReducer, { PaymentOrdersState } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.reducers';
import paymentOrdersSaga from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.sagas';
import { getBoPaymentOrdersState } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.selectors';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps {
    outputFilename: string;
    outputXML: string;
    loadingState: LoadingState;
    errorMessage: string;
}

interface DispatchProps {
    onOpenXLS(file: File);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class PaymentOrdersPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const poState: PaymentOrdersState = getBoPaymentOrdersState(state);

            return {
                outputFilename: poState.outputFilename,
                outputXML: poState.outputXML,
                loadingState: poState.loadingState,
                errorMessage: poState.errorMessage,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onOpenXLS: paymentOrdersLoadTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return 'Payment Orders';
    }

    public render(props: Props): false | JSX.Element {
        return (
            <PaymentOrders {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    // potrebujeme <a>, ale <Page>  ma zatial iba <Link>
    // caka na https://trello.com/c/7YfyTiuO/4043-21d-univerzalny-link-component-ktory-spravne-vygeneruje-interny-react-router-dom-link-alebo-a-podla-toho-ci-ide-in-app-linku
    // public getDefaultBackPath(props: Props): string {
    //     return urls.boBankPaymentsUrl;
    // }

    public getHeaderTitle(props: Props): string {
        return 'Convert Excel to payment orders for Tatrabanka';
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.bo.paymentOrders', paymentOrdersReducer);
        store.injectSaga('containers.bo.paymentOrders', paymentOrdersSaga);
    }
}
